module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents"
  }, [_c('h2', {
    staticClass: "contentsHead sigilNotInTOC",
    attrs: {
      "id": "heading_id_2"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('table', {
    staticClass: "table",
    attrs: {
      "cellspacing": "15"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "contentsEntry"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "contentsEntry3"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0004#link0"
    }
  }, [_vm._v("Introduction")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "contentsEntry"
  }, [_vm._v("I")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "contentsEntry3"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0005#link1"
    }
  }, [_vm._v("EARLY DAYS")]), _c('br'), _vm._v("\n          Childhood—School and Cadet Days—The Ensign—Student Days")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "contentsEntry"
  }, [_vm._v("II")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "contentsEntry3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0006#link2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE OUTBREAK OF WAR AND THE EVOLUTION OF AN AIRMAN")]), _c('br'), _vm._v("\n          The Outbreak of War—Mobilisation and Garrison Duty—First Flights—The Flying School—First and Second Tests—The First Crash—The Aircraft Park—The Third Tests—An Experience—The Front at Last!—Artillery Flier in the Champagne— Flying Section 62, the New Home—Affection and Loyalty—The Formation of Flying Section 62— The Youthful German Air Arm; a Survey—The Development of the Air Arm—Reconnaissances on the Somme—The First Airfight—To Arms!— Progress and Success—Lost!—Long Distance Reconnaissances—The First Scouting Flight and the First Victory—Immelmann the First Scout— The Biplane Fighter and the Fokker One-seater Fighter—Immelman and Boelcke—The Fokker Becomes Known—The Second Victory—Front and Home—The Third Victory—An Excursion and a Rough Landing—Days of Heavy Fighting—The Fourth Victory—The Fifth Victory—Modesty— Pioneers of the Air Arm—Aerial Supremacy")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "contentsEntry3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0007#link3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photo Insert")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "contentsEntry"
  }, [_vm._v("III")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "contentsEntry3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0037#link4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE EAGLE OF LILLE")]), _c('br'), _vm._v("\n          The Sixth Victory—Honoured by the King of Saxony—Leave—The Seventh—A Visit to Brunswick—The Fokker Turns Turtle—The Seventh—The Eighth—The ‘Pour le Mérite’— Christmas—Success and Comradeship—Rumours and Legends—The Ninth—A Double Event: the Tenth and Eleventh—The Tenth—The Eleventh— Questions and Answers—The Twelfth—The Thirteenth—The Emperor’s Letter—Immelman and the ‘13’—The Fourteenth—On the Active List Again and Full Lieutenant—Severe Fighting in the Air—One Year of Flying Section 62—The Fifteenth—Popularity—The Last Weeks—Shot Down by His Own Gun—The Beginnings of Formation Flying—A Premonitory Farewell—The First Combats on the Last Day—The Last Fight and the Last Victory—The End")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "contentsEntry3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0038#link5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterthoughts")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "contentsEntry3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0039#link6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: The Victories of Max Immelman")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a61bab10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0003.vue
// module id = 66
// module chunks = 0